export const setCookie = (name: string, value: string, days: number) => {
  // Only run on client side
  if (typeof document === 'undefined') {
    return;
  }

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const domain = `domain=${globalThis.location?.hostname}`;
  document.cookie = `${name}=${value};${expires};path=/;${domain}`;
};

export const getCookie = (name: string): string | null => {
  // Only run on client side
  if (typeof document === 'undefined') {
    return null;
  }

  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());

  for (const cookie of cookies) {
    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length);
    }
  }

  return null;
};
